import React, { useRef, useState } from 'react';
import { documentsService } from "../../../services";
import IconSVG from "../../../styles/svg-icons";
import { constants } from "../../../constants";
import { errorActions } from '../../../actions';
import { useDispatch } from 'react-redux';
import { Preloader } from '../../common/Preloader';
import { DownloadTemplateButton } from '../../common/download-template/DownloadTemplateButton';

export function ImportSecurities() {
    const [
        requestUploadSecurities,
        requestUploadManagerMeetings,
        fileInput,
        fileInputManagerMeetings,
        uploadSecurities,
        uploadManagerMeetings,
        securities,
        managerMeetingsUploaded
    ] = useUploadSecurities();

    const handleImportSecurities = () => {
        if (fileInput.current) fileInput.current.click()
    };

    const handleImportManagerMeetings = () => {
        if (fileInputManagerMeetings.current) fileInputManagerMeetings.current.click()
    };

    const renderContent = () => {
        if (securities && Array.isArray(securities) && securities.length) {
            return (
                <>
                    <h2>Import Results</h2>
                    <div className="import-securities-box">
                        <p>Securities Import started</p>
                        {securities.map((item, index) => {
                            return <p key={`res-item-${item}-${index}`}>{item}</p>
                        })}
                        <p>Securities Import completed</p>
                    </div>
                </>)
        }
        else if (managerMeetingsUploaded) {
            return <h2>File Uploaded Successfully</h2>;
        }
        return null;
    };

    return (
        <div className="container">
            <div className="sub-header">
                <div className="sub-header-row type04 flex-row">
                    <h1>Securities</h1>
                    <button
                        className="btn btn-ghost"
                        type="button"
                        onClick={handleImportSecurities}
                        disabled={requestUploadSecurities}
                    >
                        <IconSVG name="import" width={16} height={16} />
                        Import Securities
                    </button>
                    <button
                        className="btn btn-ghost"
                        type="button"
                        onClick={handleImportManagerMeetings}
                        disabled={requestUploadManagerMeetings}
                    >
                        <IconSVG name="import" width={16} height={16} />
                        Import Manager Meetings
                    </button>
                    <div className="flex-item-right controls">
                        <DownloadTemplateButton templateType="ManageSecuritiesXlsxTemplate" />
                    </div>
                    <input
                        ref={fileInput}
                        type="file"
                        accept={constants.acceptedTemplateExtensions}
                        style={{ display: 'none' }}
                        onChange={uploadSecurities}
                    />
                    <input
                        ref={fileInputManagerMeetings}
                        type="file"
                        accept={constants.acceptedTemplateExtensions}
                        style={{ display: 'none' }}
                        onChange={uploadManagerMeetings}
                    />
                </div>
            </div>
            <div className="import-securities">
                <Preloader inProgress={requestUploadSecurities || requestUploadManagerMeetings}>
                    {renderContent()}
                </Preloader>
            </div>
        </div>
    )
}

const useUploadSecurities = () => {
    const dispatch = useDispatch();
    const fileInput = useRef(null);
    const fileInputManagerMeetings = useRef(null);

    const [requestUploadSecurities, setRequestUploadSecurities] = useState(false);
    const [requestUploadManagerMeetings, setRequestUploadManagerMeetings] = useState(false);
    const [securities, setSecurities] = useState([]);
    const [managerMeetingsUploaded, setManagerMeetingsUploaded] = useState(false);

    const uploadSecurities = e => {
        if (e.target.files.length && fileInput.current) {
            setRequestUploadSecurities(true);
            setSecurities([]);
            documentsService.uploadSecurities(e.target.files[0])
                .then((res) => {
                    setSecurities(res || []);
                })
                .catch((err) => {
                    dispatch(errorActions.unexpectedError(err))
                })
                .finally(() => setRequestUploadSecurities(false));
            fileInput.current.value = "";
        }
    };

    const uploadManagerMeetings = e => {
        if (e.target.files.length && fileInputManagerMeetings.current) {
            setRequestUploadManagerMeetings(true);
            setManagerMeetingsUploaded(true);
            documentsService.uploadManagerMeetings(e.target.files[0])
                .then(() => {
                    setManagerMeetingsUploaded(true);
                })
                .catch((err) => {
                    dispatch(errorActions.unexpectedError(err))
                })
                .finally(() => setRequestUploadManagerMeetings(false));
            fileInputManagerMeetings.current.value = "";
        }
    };

    return [
        requestUploadSecurities,
        requestUploadManagerMeetings,
        fileInput,
        fileInputManagerMeetings,
        uploadSecurities,
        uploadManagerMeetings,
        securities,
        managerMeetingsUploaded]
};
